<template>
    <div class="privacy-container">
        <h1 style="text-align: center">XUS数字商城隐私协议</h1>
        <div class="privacy-content">
            <p><strong>版本号：V1.0</strong></p>
            <p><strong>生效日期：2023-10-01</strong></p>

            <h2>1. 信息收集范围</h2>
            <p>1.1 必要信息：</p>
            <ul style="margin-left: 40px">
                <li>用户身份（企业营业执照/个人身份证）；</li>
                <li>服务器IP、域名、联系方式（电话/邮箱）；</li>
                <li>支付信息（通过支付宝/微信支付，我方不存储银行卡号）。</li>
            </ul>
            <p>1.2 非必要信息：</p>
            <ul style="margin-left: 40px">
                <li>用户可自愿提供公司简介、LOGO等用于系统配置。</li>
            </ul>

            <h2>2. 信息使用目的</h2>
            <p>2.1 仅用于：</p>
            <ul style="margin-left: 40px">
                <li>系统授权与激活；</li>
                <li>安全更新通知；</li>
                <li>违规行为调查与法律配合。</li>
            </ul>
            <p>2.2 绝不用于：</p>
            <ul style="margin-left: 40px">
                <li>出售或共享给第三方营销；</li>
                <li>未经用户同意的商业推广。</li>
            </ul>

            <h2>3. 数据存储与安全</h2>
            <p>3.1 用户业务数据（如订单、会员信息）存储于其自有服务器，我方无权访问。</p>
            <p>3.2 我方仅存储：</p>
            <ul style="margin-left: 40px">
                <li>用户账号（用于登录技术支持平台）；</li>
                <li>系统日志（用于故障排查）。</li>
            </ul>

            <h2>4. 用户权利</h2>
            <p>4.1 查询与更正：用户可要求查看或修改提交的信息。</p>
            <p>4.2 注销账号：终止服务后，用户可申请删除我方数据库中的信息（法律要求的留存除外）。</p>

            <h2>5. 监管配合</h2>
            <p>5.1 如用户涉嫌违法，我方将依法向监管部门提供：</p>
            <ul style="margin-left: 40px">
                <li>注册信息；</li>
                <li>系统访问日志（如有）。</li>
            </ul>

            <h2>6. 协议更新</h2>
            <p>6.1 修改本协议需提前15天在官网公示，重大变更将通过邮件通知。</p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PrivacyPolicy',
    props: {
        showCheckbox: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            isAgreed: false
        }
    },
    watch: {
        isAgreed(newVal) {
            this.$emit('agreement-change', newVal);
        }
    }
}
</script>

<style scoped>
.privacy-container {
    width: 80%;
    margin: 0 auto;
    overflow-y: auto;
    padding: 20px;
    border: 1px solid #eee;
    margin-bottom: 20px;
    background-color: #f9f9f9;
}
.privacy-content {
    text-align: left;
    line-height: 1.6;
    font-size: 14px;
}
.privacy-content h2 {
    font-size: 16px;
    margin-top: 20px;
    margin-bottom: 10px;
    color: #333;
}
.privacy-content p, .privacy-content ul {
    margin-bottom: 10px;
}
.privacy-checkbox {
    margin-top: 20px;
    padding: 10px;
    background-color: #f5f5f5;
    border-radius: 4px;
}
.privacy-checkbox input {
    margin-right: 8px;
}
</style>